import React from "react";
import { Input, Avatar, Select, Icon, Row, Col, Tooltip } from "antd";
import { Trans, useTranslation } from "react-i18next";

import Upload from "../../components/controls/Upload";
import { getOptimizedImage } from "../../utils/images";
import { Field } from "../../components/controls/FormikForm";
import { applicationLanguages } from "../../utils/data/static/applicationLanguages";

import styled from "styled-components/macro";

const FormWrapper = styled.div`
  .avatar-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }

  .avatar {
    margin-right: 16px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .mr10 {
    margin-right: 10px;
  }
`;

const WrapperLanguage = styled.div`
  background: ${({ isNewCompany }) => !isNewCompany && "#fff6eb"};
  padding: ${({ isNewCompany }) => !isNewCompany && "20px"};
  border-radius: 8px;
`;

const TextLanguage = styled.p`
  color: ${({ theme }) => theme["@gray-60"]};
  font-size: 14px;
`;

const CustomIcon = styled(Icon)`
  color: ${({ theme }) => theme["@orange"]} !important;
  font-size: 24px;
  margin-right: 20px;
`;

const ProfileFormInputs = ({
  values,
  isNewCompany = false,
  isHeadquarter = false,
  setFieldValue,
  type = "company",
  setPrefix
}) => {
  const { t } = useTranslation();

  const selectBefore = (
    <Select
      onChange={setPrefix}
      defaultValue="https://"
      className="select-before"
    >
      <Select.Option value="https://">https://</Select.Option>
      <Select.Option value="http://">http://</Select.Option>
    </Select>
  );

  return (
    <FormWrapper>
      <Row gutter={20} type="flex" justify="center">
        <Col xs={24} md={12}>
          <Field name="name" label={t("global:name")} showRequiredMark={true}>
            <Input disabled={!isNewCompany} data-test="company-name" />
          </Field>
        </Col>
        <Col xs={24} md={12}>
          <div className="ant-form-item-label">
            <label title={t("company:profile.logo")}>
              {t("company:profile.logo")}
            </label>
          </div>
          <div className="avatar-container">
            <Avatar
              size={60}
              icon="shop"
              src={values.logo && getOptimizedImage(values.logo)}
              shape="circle"
              className="avatar"
            />
            <Upload
              fileType="image/*"
              label={t("company:profile.selectImage")}
              options={{ upload_preset: "opportunity" }}
              action={process.env.REACT_APP_CLOUDINARY_IMAGE_URL}
              onChange={file => setFieldValue("logo", file)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={20} type="flex" justify="center">
        <Col xs={24} md={12}>
          <WrapperLanguage isNewCompany={isNewCompany}>
            <Field
              name="country"
              label={t("global:language")}
              showRequiredMark={true}
            >
              <Select
                showSearch
                optionFilterProp="children"
                data-test="country-select"
              >
                {applicationLanguages.map(({ country, label }) => (
                  <Select.Option key={country} value={country}>
                    {label}
                  </Select.Option>
                ))}
              </Select>
            </Field>
            {!isNewCompany && (
              <div style={{ display: "flex" }}>
                <CustomIcon type="info-circle" />
                <TextLanguage>
                  <Trans i18nKey="user:profile.textLanguage">
                    Si deseas cambiar el idioma en que utilizas Worcket puedes
                    ir a tu perfil personal haciendo
                    <a
                      href={"/usuario/perfil"}
                      className="font-bold text-primary"
                    >
                      click aquí
                    </a>
                  </Trans>
                </TextLanguage>
              </div>
            )}
          </WrapperLanguage>
        </Col>
        <Col xs={24} md={12}>
          <Field name="description" label={t("company:profile.description")}>
            <Input.TextArea rows={7} style={{ resize: "none" }} />
          </Field>
        </Col>
      </Row>
      <Row gutter={20} type="flex" justify="center">
        <Col xs={24} md={12}>
          <Field
            name="address"
            label={t("company:profile.address")}
            showRequiredMark={true}
          >
            <Input />
          </Field>
        </Col>
        <Col xs={24} md={12}>
          <Field name="slogan" label={t("global:slogan")}>
            <Input />
          </Field>
        </Col>
      </Row>
      <Row gutter={20} type="flex" justify="center">
        <Col xs={24} md={12}>
          <Field
            name="website"
            label={t("company:profile.website")}
            placeholder="http://"
          >
            <Input />
          </Field>
          {type !== "company" && (
            <Field showRequiredMark={true} name="loginUrl" label="URL login">
              <Input addonBefore={selectBefore} />
            </Field>
          )}
        </Col>
        <Col xs={24} md={12}>
          <Field name="industry" label={t("company:profile.industry")}>
            <Input />
          </Field>
        </Col>
      </Row>
      <Row gutter={20} type="flex" justify="center">
        <Col xs={24} md={12}>
          {!isHeadquarter && (
            <Field
              name="tyc"
              label={
                <span>
                  <span className="mr10">{t("company:profile.tyc")}</span>
                  <Tooltip
                    placement="top"
                    title={t("company:profile.tycTooltip")}
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                </span>
              }
              placeholder="http://"
            >
              <Input />
            </Field>
          )}
        </Col>
        <Col xs={24} md={12}></Col>
      </Row>
    </FormWrapper>
  );
};

export default ProfileFormInputs;
